"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _UserContext = require("@insided/shared/services/UserContext");

var _zod = require("zod");

var widgetName = 'gainsight-px-activation'; // the data config

exports.widgetName = widgetName;
var cssAnchorName = 'widget-gainsight-px-activation';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  communityId: _zod.z.string()
});

exports.config = config;

var GainsightPxActivation = function GainsightPxActivation(_ref) {
  var communityId = _ref.communityId;
  return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
    if (!user.id) {
      return null;
    }

    return (0, _preact.h)("script", {
      dangerouslySetInnerHTML: {
        __html: createGainsightPxActivationScript(communityId, user)
      }
    });
  });
}; // default export is the component


var _default = GainsightPxActivation;
exports.default = _default;

var createGainsightPxActivationScript = function createGainsightPxActivationScript(communityId, user) {
  var userData = {
    id: "".concat(communityId, ":").concat(user.id)
  };
  var communityData = {
    id: communityId
  };
  var userArgument = JSON.stringify(userData);
  var communityArgument = JSON.stringify(communityData);
  return "aptrinsic(\"identify\",".concat(userArgument, ",").concat(communityArgument, "); \n          aptrinsic('set', 'globalContext', {'interface': 'Control'});");
};